import React from 'react';
import { useAuth } from '../context/AuthContext';

export const Teacher = () => {
  const { user } = useAuth();

  return (
    <div style={{ maxWidth: 1100, margin: '40px auto', padding: '0 20px' }}>
      <h1>Pedagog paneli</h1>
      <p>Xush kelibsiz, <strong>{user?.first_name || user?.username}</strong>!</p>
    </div>
  );
};
